export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7369.474d82f3.jpg";